import { GzChatCardWebComponent } from './component/GzChatCardWebComponent';

export { GzChatCardWebComponent };
